import {ReactNode, useEffect} from 'react';
import {useMyAccessRestriction} from '@/api/access-restriction';
import {useAccessRestrictionModal} from '@/components/AccessRestrictionModalSystem';
import {Splash} from '@/components/Splash';
import {useSession} from '@/hooks/session';

/**
 * 지도 진입 판정. 메뉴 클릭·주소 직접 입력·새로고침·로그인 후 복귀 모두 이 라우트를 거친다.
 * 제한 중이면 지도를 그리지 않고 안내 모달만 띄운다. 판정 요청이 실패하면 지도를 보여준다
 * (지도·분석 API는 서버가 한 번 더 막는다).
 */
export const AccessRestrictionRoute = ({
  children,
}: {
  children: ReactNode[] | ReactNode;
}) => {
  const {user} = useSession();
  const {data: restriction, isPending} = useMyAccessRestriction(user?.id);
  const openModal = useAccessRestrictionModal();

  useEffect(() => {
    if (restriction) {
      openModal(restriction);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restriction]);

  if (isPending) {
    return <Splash />;
  } else if (restriction) {
    return null;
  }

  return <>{children}</>;
};

export default AccessRestrictionRoute;
